import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import {
  prepareRealtyTypeFilterOptions,
  useBestOffers,
} from 'entities/kyrgyzstan/lib'
import {
  kyrgyzstanDetailContextStore,
  kyrgyzstanRealtyTypesStore,
} from 'entities/kyrgyzstan/model'

import { BestOffersFilters, BestOffersGrid, BestOffersHeader } from './ui'

export interface BestOffersProps {
  limit?: number
  className?: string
  isShowHeader?: boolean
}

export const BestOffers = observer(
  ({ limit, className, isShowHeader = true }: BestOffersProps) => {
    const navigate = useNavigate()

    const {
      offers,
      isLoading,
      error,
      allOffers,
      realtyTypeId,
      setRealtyTypeId,
    } = useBestOffers({
      limit,
    })

    const { realtyTypes, fetchRealtyTypes } = kyrgyzstanRealtyTypesStore

    const activeOptionId = realtyTypeId || 0
    const filteredOffers = limit ? offers : allOffers
    const filterOptions = prepareRealtyTypeFilterOptions(realtyTypes)

    useEffect(() => {
      fetchRealtyTypes({
        is_favor: true,
      })
    }, [fetchRealtyTypes])

    const handleCardClick = (id: string) => {
      kyrgyzstanDetailContextStore.setContext({
        parentId: id,
      })

      navigate(RoutingPaths.kyrgyzstan.detail.path(id))
    }

    const handleViewAll = () => {
      navigate(RoutingPaths.kyrgyzstan.bestOffers.path())
    }

    return (
      <div className={className}>
        {isShowHeader && <BestOffersHeader onViewAll={handleViewAll} />}

        <BestOffersFilters
          activeOptionId={activeOptionId}
          onOptionIdChange={setRealtyTypeId}
          options={filterOptions}
        />

        <BestOffersGrid
          offers={filteredOffers}
          isLoading={isLoading}
          error={error}
          onOfferClick={handleCardClick}
        />
      </div>
    )
  },
)
